module.exports = __webpack_public_path__ + "media/images/favicons/android-chrome-72x72-e2c8f6f901b348a90c192461dbac3f11.png";